module.exports = __webpack_public_path__ + "img/txt_info2.3a71f1c2.png";